module.exports = __webpack_public_path__ + "static/img/4bg_18.3183668.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/4bg_18.png
// module id = 712
// module chunks = 1